import React, { useEffect, useRef, useState } from "react";
import Lottie from "lottie-react";
import { createPortal } from "react-dom";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";

import LottieAnimation from "../../../assets/json/sezione-05-popup-03-00-en.json";

import IcoGialla from "../../../assets/images/btn-freccia-giallo-01.svg";
import IcoAzzurra from "../../../assets/images/btn-freccia-azzurro-01.svg";

import BeneficioComune from "./en-sezione-5-Sostenibilita-approfondimento-1";
import PSIPopup from "./en-sezione-5-Sostenibilita-approfondimento-2";
import MutualitaSostenibilita from "./en-sezione-5-Sostenibilita-approfondimento-3";
import MissionVisionPurpose from "./en-sezione-5-Sostenibilita-approfondimento-4";
import ContestoAccordion from "./en-sezione-5-Sostenibilita-contesto";
import arrowIconWhite from "../../../assets/images/arrowIconWhite.png";

export default function ModelloSostenibilita({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  // Popup
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);

  const mobileActionsRef = useRef(null);

  // Mobile: mostra/nascondi i 4 pulsanti
  const [showMobileActions, setShowMobileActions] = useState(false);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const onShare = (popupId) => {
    const url = new URL(window.location.href);
    url.searchParams.set("popup", popupId);

    if (navigator.share) {
      navigator
        .share({ title: "Sustainability Model", url: url.toString() })
        .catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url.toString()).catch(() => {});
    }
  };

  return createPortal(
    <>
      <div
        ref={overlayRef}
        className="fixed inset-0 z-[999] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
        onMouseDown={(e) => {
          if (e.target === overlayRef.current) onClose?.();
        }}
        role="dialog"
        aria-modal="true"
        aria-label="Sustainability Model"
      >
        <div
          className="
            relative w-full md:w-[1280px] bg-[#E7E3DF] p-6 md:p-8
            max-h-[90vh] overflow-y-auto overscroll-contain
          "
          style={{ background: "#E7E3DF", WebkitOverflowScrolling: "touch" }}
        >
          {/* Azioni in alto */}
          <div className="sticky top-3 z-10 flex items-center gap-2 justify-end pr-3">
            <button
              onClick={() => onShare("ModelloSostenibilita")}
              className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
              title="Share"
              aria-label="Share"
            >
              <img src={shareIcon} alt="" className="h-4 w-4" />
            </button>
            <button
              onClick={onClose}
              className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
              title="Close"
              aria-label="Close"
            >
              <img src={closeIcon} alt="Close" className="h-4 w-4" />
            </button>
          </div>

          <h2 className="text-[#A3648F] text-[30px] md:text-[40px] font-bold">
            Sustainability Model
          </h2>

          {/* Contenuto */}
          <div className="flex flex-col items-center p-4 md:p-8 relative w-full md:w-[950px] mx-auto">
            {/* Accordion Global context / Market / Regulation (sopra all'infografica) */}
            <ContestoAccordion />

            {/* Lottie + CTA mobile */}
            <div className="relative w-full">
              <Lottie
                animationData={LottieAnimation}
                loop={false}
                autoplay
                className="w-full h-auto"
              />

              {/* Bottone mobile centrato sopra al Lottie */}
                <div className="md:hidden absolute -top-[170px] left-1/2 translate-x-[-50%] inset-[20px] flex items-center justify-center">
                  <button
                    type="button"
                    onClick={() => {
                      const next = !showMobileActions;
                      setShowMobileActions(next);
                      if (next) {
                        setTimeout(() => {
                          mobileActionsRef.current?.scrollIntoView({ behavior: "smooth" });
                        }, 300); // aspetta la transizione
                      }
                    }}
                    aria-expanded={showMobileActions}
                    className="bt-secondary2 mt-0"
                    style={{ fontSize: "14px", fontWeight: "500" }}
                  >
                    {showMobileActions ? "Close" : "Discover more"}
                  </button>
                </div>

              {/* 3 BOTTONI INTERATTIVI (DESKTOP) — sopra l'anello del Lottie */}
              <button
                type="button"
                onClick={() => setOpen3(true)}
                className="hidden md:flex flex-col items-center justify-center text-center gap-1 cursor-pointer rounded-full absolute -translate-x-1/2 -translate-y-1/2 w-[140px] h-[140px] px-2 hover:brightness-105 transition"
                style={{ left: "41%", top: "21%", background: "#f0b500" }}
              >
                <span className="text-[13px] font-bold uppercase leading-[1.1]" style={{ color: "#002355" }}>
                  Mutuality<br />Sustainability
                </span>
                <img src={IcoAzzurra} alt="" className="w-[26px]" />
              </button>

              <button
                type="button"
                onClick={() => setOpen4(true)}
                className="hidden md:flex flex-col items-center justify-center text-center gap-1 cursor-pointer rounded-full absolute -translate-x-1/2 -translate-y-1/2 w-[140px] h-[140px] px-2 hover:brightness-110 transition"
                style={{ left: "59%", top: "21%", background: "#004291" }}
              >
                <span className="text-[16px] font-bold uppercase leading-[1.1] text-white">
                  Purpose
                </span>
                <img src={IcoAzzurra} alt="" className="w-[26px] mt-3" />
              </button>

              <button
                type="button"
                onClick={() => setOpen1(true)}
                className="hidden md:flex flex-col items-center justify-center text-center gap-1 cursor-pointer rounded-full absolute -translate-x-1/2 -translate-y-1/2 w-[140px] h-[140px] px-3 hover:brightness-110 transition"
                style={{ left: "50%", top: "33%", background: "#002a5c" }}
              >
                <span className="text-[12px] font-bold uppercase leading-[1.15] text-white">
                  Benefit Corporation<br />and 6 Common Benefit<br />Purposes
                </span>
                <img src={arrowIconWhite} alt="" className="w-[26px]" />
              </button>
            </div>

            {/* Mobile: i 3 pulsanti (appaiono dopo "Discover more") */}
            <div
              ref={mobileActionsRef}
              className={`
                md:hidden w-full
                transition-all duration-300 ease-out
                ${showMobileActions ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2 pointer-events-none"}
              `}
            >
              <div
                className="
                  flex mt-8 flex-row items-center justify-between gap-2
                  rounded-full w-full py-[8px] px-[8px]
                  border-[1px] border-[#f0b500]
                "
              >
                <button
                  className="text-[14px] font-semibold text-[#f0b500] uppercase"
                  onClick={() => setOpen3(true)}
                >
                  Mutuality Sustainability
                </button>
                <img src={IcoGialla} className="w-[18px]" />
              </div>

              <div
                className="
                  flex mt-2 flex-row items-center justify-between gap-2
                  rounded-full w-full py-[8px] px-[8px]
                  border-[1px] border-[#004291]
                "
              >
                <button
                  className="text-[14px] font-semibold text-[#004291] uppercase"
                  onClick={() => setOpen4(true)}
                >
                  Purpose
                </button>
                <img src={IcoAzzurra} className="w-[18px]" />
              </div>

              <div
                className="
                  flex mt-2 flex-row items-center justify-between gap-2
                  rounded-full w-full py-[8px] px-[8px]
                  border-[1px] border-[#002a5c]
                "
              >
                <button
                  className="text-[14px] font-semibold text-[#002a5c] uppercase"
                  onClick={() => setOpen1(true)}
                >
                  Benefit Corporation and 6 Common Benefit Purposes
                </button>
                <img src={IcoAzzurra} className="w-[18px]" />
              </div>
            </div>
          </div>

          <a
            href="https://www.realegroup.eu/groupshare/0/EN/ListaSustainabilityReports/37/EXECUTIVE%20SUMMARY%202025_EN.pdf#page=17"
            target="_blank"
          >
            <button type="button" className="bt-secondary2 text-sm px-4 py-2 mt-8">
              <img
                src={arrowIconWhite}
                alt="Arrow"
                className="inline-block mr-2 w-[20px] h-[20px]"
              />
              Consult the Executive Summary - chapter 1
            </button>
          </a>
        </div>
      </div>

      {/* MODALI FIGLIO (PORTAL) */}
      <BeneficioComune isOpen={open1} onClose={() => setOpen1(false)} />
      <PSIPopup isOpen={open2} onClose={() => setOpen2(false)} />
      <MutualitaSostenibilita isOpen={open3} onClose={() => setOpen3(false)} />
      <MissionVisionPurpose isOpen={open4} onClose={() => setOpen4(false)} />
    </>,
    document.body
  );
}
